module.exports = __webpack_public_path__ + "static/team-katerina-17e4c41369e741bcdb7c01e770da67bd.jpg";